import React from "react";

export default function ClaimPropertyButton({
  claimState,
  canRoleClaim,
  onClaim,
  styles,
  badgeStyle,
}) {
  if (!claimState?.canOpenClaim) {
    return (
      <span style={{ ...badgeStyle, width: "100%", justifyContent: "center", boxSizing: "border-box" }}>
        {claimState?.label || "Claim Pending Review"}
      </span>
    );
  }

  return (
    <button
      type="button"
      style={{
        ...styles.primaryButton,
        width: "100%",
        ...(canRoleClaim ? {} : { opacity: 0.6, cursor: "not-allowed" }),
      }}
      onClick={onClaim}
    >
      {claimState.label}
    </button>
  );
}
